const doc = [({"da":({"js":({"admin":({"economy":({"accounts":({"index":({"account_dimensions":"Konto dimensioner"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;